export const REQUEST_REDIRECT_TO_SSO = '@integrations/oauth/REQUEST_REDIRECT_TO_SSO';
export const REQUEST_REDIRECT_TO_INTEGRATIONS_HOME = '@integrations/oauth/REQUEST_REDIRECT_TO_INTEGRATIONS_HOME';
export const START_INTEGRATION_FLOW = '@integrations/oauth/START_INTEGRATION_FLOW';
export const THROW_INTEGRATION_FLOW_ERROR = '@integrations/oauth/THROW_INTEGRATION_FLOW_ERROR';
export const THROW_INTEGRATION_FLOW_WARNING = '@integrations/oauth/THROW_INTEGRATION_FLOW_WARNING';

export const SEND_AUTHORIZATION_CODE_REQUEST_CALLED = '@integrations/oauth/SEND_AUTHORIZATION_CODE_REQUEST_CALLED';
export const SEND_AUTHORIZATION_CODE_REQUEST_SUCCESS = '@integrations/oauth/SEND_AUTHORIZATION_CODE_REQUEST_SUCCESS';
export const SEND_AUTHORIZATION_CODE_REQUEST_FAIL = '@integrations/oauth/SEND_AUTHORIZATION_CODE_REQUEST_FAIL';
export const SEND_AUTHORIZATION_CODE_REQUEST_FINISH = '@integrations/oauth/SEND_AUTHORIZATION_CODE_REQUEST_FINISH';

export const requestRedirectToSSO = (issuerUrl: string) => ({
    type: REQUEST_REDIRECT_TO_SSO,
    payload: { url: issuerUrl },
});

export const requestRedirectToIntegrationsHome = (platformIntegrated = null) => ({
    type: REQUEST_REDIRECT_TO_INTEGRATIONS_HOME,
    payload: platformIntegrated,
});

export type IntegrationFlowParams = {
  providerId: string,
  authorizationServerUrl: string
  state: string
  params:{
    code: string
    [additionalKey: string]: string
  }
}

export const startIntegrationFlow = ({
    providerId,
    authorizationServerUrl,
    state,
    params,
}: IntegrationFlowParams) => ({
    type: START_INTEGRATION_FLOW,
    payload: {
        providerId,
        authorizationServerUrl,
        state,
        params,
    },
});

export const throwIntegrationFlowError = (
    message: string,
    phase: string,
) => ({
    type: THROW_INTEGRATION_FLOW_ERROR,
    payload: { message, phase },
});

export const throwIntegrationFlowWarning = (
    message: string,
    phase: string,
) => ({
    type: THROW_INTEGRATION_FLOW_WARNING,
    payload: { message, phase },
});

export const sendAuthorizationCode = ({
    params,
    authorizationServerUrl,
    providerId,
}) => ({
    type: SEND_AUTHORIZATION_CODE_REQUEST_CALLED,
    actionTypes: {
        fail: SEND_AUTHORIZATION_CODE_REQUEST_FAIL,
        success: SEND_AUTHORIZATION_CODE_REQUEST_SUCCESS,
        finish: SEND_AUTHORIZATION_CODE_REQUEST_FINISH,
    },
    config: {
        url: authorizationServerUrl,
        method: 'POST',
        data: params,
    },
    payload: {
        providerId,
    },
});
